<template>

</template>

<script>

    import languageSwitch from 'components/button/languageSwitch.vue'

    export default {
        components: {
            languageSwitch
        },
        data() {
            return {
                navPopupOpen: false,
                subNavElements: ''
            };
        },
        watch: {
            navPopupOpen: function (isOpen) {
                if (isOpen) {
                    document.body.classList.add('overflow-hidden');
                } else {
                    document.body.classList.remove('overflow-hidden');
                    //if Nav gets closed, also close all subNavs
                    for (let subNav of this.subNavElements) {
                        subNav.classList.remove('open')
                    }
                }
            },
        },
        created(){

        },
        mounted() {
            Event.$on("burgerIconClick", (isOpen) => this.toggleNav(isOpen));

            //remove hardcoded class 'hidden' which is there to prevent flickering on page load
            $(".mobile-nav-popup").each(function() {
                $(this).removeClass("hidden");
            });
        },
        methods: {
            toggleSubNav(event){
                let subNav = $(event.target).parent().parent().next('ul') //subNav which should be opened by the touch
                let nav = $('nav.mobile');

                //toggle class hidden
                if ($(subNav).hasClass('open')) {
                    $(subNav).removeClass('open');
                    $(nav).removeClass('open');
                } else {
                    $(subNav).addClass('open');
                    $(nav).addClass('open');
                }
            },
        }
    };
</script>

<style rel="stylesheet/scss" lang="scss" type="text/css" scoped>

    nav {
        z-index:1000;
        height:60vh;
        &.open {
            //height:60vh;
        }

        a {
            &.active {
                padding-top:4px;
                &:after {
                    content: '';
                    border-bottom: 2px solid #fff;
                    width: 97%;
                    display: block;
                    margin-left: 1px;
                    padding-bottom:2px;
                }
            }
        }

        & .subnav__arrow-down {
            position: absolute;
            right: -30px;
            top: 8px;
        }


    }

    /* Subnav */
    ul > li > ul {
        max-height: 0;
        opacity:0;
        transition: all 0.3s ease-in-out;
        overflow: hidden;

        &.open {
            max-height: 500px;
            opacity:1;
            transition: all 0.3s ease-in-out;
        }
    }

</style>
